/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 */

import { createContext, useContext, useEffect, useState } from "react";

// Platform theming. Applies data-theme to <html>; tokens live in styles.css.
// Persisted in localStorage so the choice survives reloads and sessions.
const ThemeContext = createContext(null);
const KEY = "bc-theme";
export const THEMES = ["light", "dark"];

function initialTheme() {
  try {
    const saved = localStorage.getItem(KEY);
    if (THEMES.includes(saved)) return saved;
  } catch { /* ignore */ }
  return "dark"; // dark is the hero theme
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(initialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  function setTheme(next) {
    if (!THEMES.includes(next)) return;
    setThemeState(next);
    try { localStorage.setItem(KEY, next); } catch { /* ignore */ }
  }

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme must be used inside ThemeProvider");
  return ctx;
}
